module.exports = __webpack_public_path__ + "img/trophy.152af5a5.png";